import { useCallback } from "react";

import { chatSessionFunctionCallVar } from "@apps/ask-ai/ask-ai";
import usePusher from "@components/use-pusher/use-pusher";

export default function PusherChatMessageFunctionCall({
  channelName,
}: {
  channelName: string;
}) {
  const handleChatMessageFunctionCall = useCallback(
    ({
      chat_session_id,
      function_name,
      parameters,
    }: {
      chat_session_id: number;
      function_name: string;
      parameters: any;
    }) => {
      chatSessionFunctionCallVar({
        chatSessionId: chat_session_id,
        functionName: function_name,
        parameters,
      });
    },
    []
  );

  usePusher(
    channelName,
    "chat_message_function_call",
    handleChatMessageFunctionCall
  );

  return null;
}
